import { usePersistedRoadmapControls } from '@griply/hooks';
import { RoadmapPlatform, RoadmapViewSettings } from '@griply/types';
import { useUpdateGoal } from 'features/goals';
import { useCallback } from 'react';
import { useToday } from 'shared/contexts/today';
import { Goal } from 'shared/types/goal';

export const useGoalRoadmapControls = (goal: Goal | undefined) => {
  const today = useToday();
  const { submit: updateGoal } = useUpdateGoal();
  const goalId = goal?.id;

  const onUpdateRoadmap = useCallback(
    (roadmap: RoadmapViewSettings) => {
      if (!goalId) {
        return;
      }
      updateGoal({ id: goalId, roadmap });
    },
    [goalId, updateGoal],
  );

  return usePersistedRoadmapControls({
    roadmap: goal?.roadmap,
    onUpdateRoadmap,
    today,
    platform: RoadmapPlatform.Web,
  });
};
